import { useAppContext } from "contexts/AppContext";
import React from "react";
import { Badge, Button, Form, Offcanvas, Row } from "react-bootstrap";
import {
  ArrowClockwise,
  ArrowLeftRight,
  ExclamationCircle,
  Gear,
  QuestionCircle,
  Router,
  Wifi,
  WifiOff,
  XCircle,
} from "react-bootstrap-icons";
import SettingsRow from "./SettingsRow";

const Settings = () => {
  const { appState, setAppState } = useAppContext();
  const networkStatusMap = {
    Excellent: {
      bg: "success",
    },
    Good: {
      bg: "primary",
    },
    Poor: {
      bg: "warning",
      text: "dark",
      icon: <ExclamationCircle className="me-1" size={16}/>,
    },
    Unknown: {
      bg: "secondary",
      icon: <QuestionCircle className="me-1" size={16} />,
    },
    "No Connection": {
      bg: "danger",
      icon: <XCircle className="me-1" size={16} />,
    },
  };

  return (
    <React.Fragment>
      <Offcanvas
        show={appState.settings.show}
        onHide={() => setAppState({ key: "settings.show", value: false })}
        placement="end"
      >
        <Offcanvas.Header closeButton closeLabel="">
          <Gear size={30} />
          <h3 className="my-0 mx-2">Settings</h3>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <h4>System</h4>
          <Row className="justify-content-between">
            <Form.Label className="w-auto">
              <h6 className="w-auto">
                <Router className="me-2" size={16} />
                Network Status
              </h6>
            </Form.Label>
            <span className="w-auto">
              <Badge
                bg={networkStatusMap[appState.settings.internet.quality]?.bg}
                text={
                  networkStatusMap[appState.settings.internet.quality]?.text
                }
              >
                {networkStatusMap[appState.settings.internet.quality]?.icon}
                {appState.settings.internet.quality}
              </Badge>
            </span>
          </Row>
          <Row className="justify-content-between">
            <Form.Label className="w-auto">
              <h6 className="w-auto">
                {appState.settings.internet.online && <Wifi className="me-2" size={16} />}
                {!appState.settings.internet.online && (
                  <WifiOff className="me-2" size={16}/>
                )}
                Offline Mode
              </h6>
            </Form.Label>
            <span className="d-flex w-auto">
              <Form.Check
                id="view-mode-switch"
                type="switch"
                className="w-auto mx-2 w-50 h-100"
                checked={!appState.settings.internet.online}
                onChange={(e) => {
                  setAppState({
                    key: "settings.internet.online",
                    value: !e.target.checked,
                  });
                  localStorage.setItem("offlineMode", e.target.checked);
                }}
              ></Form.Check>
            </span>
          </Row>
          <SettingsRow
            Icon={ArrowLeftRight}
            text={
              <React.Fragment>
                Autosync
                <Badge bg="danger" className="ms-2">
                  {JSON.parse(localStorage.getItem("sales") || "[]").length}
                </Badge>
                <Badge className="ms-1">
                  {Math.floor(appState.settings.autoSyncTime / 60)}:
                  {appState.settings.autoSyncTime % 60 > 9
                    ? appState.settings.autoSyncTime % 60
                    : `0${appState.settings.autoSyncTime % 60}`}
                </Badge>
              </React.Fragment>
            }
            Setting={() => (
              <Form.Check
                id="view-mode-switch"
                type="switch"
                className="w-auto mx-2 w-50 h-100"
                checked={appState.settings.autoSync}
                disabled
                onChange={(e) => {
                  setAppState({
                    key: "settings.autoSync",
                    value: e.target.checked,
                  });
                  localStorage.setItem("autoSync", e.target.checked);
                }}
              ></Form.Check>
            )}
          />
          <SettingsRow
            Icon={ArrowClockwise}
            text="Reload App"
            Setting={() => (
              <Button
                id="reload-app"
                className="m-2 btn-sm"
                onClick={(e) => location.reload()}
              >
                Reload
              </Button>
            )}
          />
          {appState.settings.moreSettings && (
            <React.Fragment>
              <h4 className="mt-5">More</h4>
              <appState.settings.moreSettings />
            </React.Fragment>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </React.Fragment>
  );
};

export default Settings;
